const TABLET_MAX_WIDTH = 1280;

const isTabletUserAgent = (): boolean => {
  if (typeof navigator === "undefined") return false;

  const ua = navigator.userAgent;

  if (/iPad|Android(?!.*Mobile)/i.test(ua)) {
    return true;
  }

  if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) {
    return true;
  }

  if (/Windows/i.test(ua) && /Touch/i.test(ua)) {
    return true;
  }

  return false;
};

export const checkIsTablet = (): boolean => {
  if (typeof window === "undefined") return false;
  return window.innerWidth <= TABLET_MAX_WIDTH || isTabletUserAgent();
};
